export default function escapeRegexString(string) {
  return string.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')
}



// WEBPACK FOOTER //
// ../src/utils/escapeRegexString.js